import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";

export function useReviewActions(reviewId: string) {
  const queryClient = useQueryClient();

  const likeMutation = useMutation({
    mutationFn: async () => {
      const response = await apiRequest("POST", `/api/reviews/${reviewId}/like`);
      return response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['/api/reviews'] });
      queryClient.invalidateQueries({ queryKey: ['/api/reviews/liked'] });
    },
  });

  const saveMutation = useMutation({
    mutationFn: async () => {
      const response = await apiRequest("POST", `/api/reviews/${reviewId}/save`);
      return response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['/api/reviews/saved'] });
    },
  });

  return {
    toggleLike: likeMutation.mutate,
    toggleSave: saveMutation.mutate,
    isLiking: likeMutation.isPending,
    isSaving: saveMutation.isPending,
  };
}

export function useUserReviews() {
  return useQuery<any[]>({
    queryKey: ['/api/reviews/me'],
  });
}

export function useLikedReviews() {
  return useQuery<any[]>({
    queryKey: ['/api/reviews/liked'],
  });
}

export function useSavedReviews() {
  return useQuery<any[]>({
    queryKey: ['/api/reviews/saved'],
  });
}

export function useDeleteReview() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (reviewId: string) => {
      const response = await apiRequest("DELETE", `/api/reviews/${reviewId}`);
      return response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['/api/reviews'] });
      queryClient.invalidateQueries({ queryKey: ['/api/reviews/me'] });
    },
  });
}

export function useUpdateReview() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async ({ reviewId, updates }: { reviewId: string; updates: any }) => {
      const response = await apiRequest("PUT", `/api/reviews/${reviewId}`, updates);
      return response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['/api/reviews'] });
      queryClient.invalidateQueries({ queryKey: ['/api/reviews/me'] });
    },
  });
}
